import { useQuery } from "@tanstack/react-query";
import { auditLogKeys } from "@/lib/query";

export interface AuditLogEntry {
  id: string;
  createdAt: string;
  adminId: string;
  adminName: string;
  entityType: string;
  tableName: string;
  entityId: string;
  entityName: string;
  changeType: string;
  beforeValue: string | null;
  afterValue: string | null;
  bulkImportId: string | null;
}

export interface AuditLogListResponse {
  data: AuditLogEntry[];
  nextCursor: string | null;
  prevCursor: string | null;
  hasNext: boolean;
  hasPrev: boolean;
  total: number;
}

export interface AuditLogParams {
  limit?: number;
  cursor?: string | null;
  entityType?: string;
  tableName?: string;
  entityName?: string;
  changeType?: string;
  adminId?: string;
  startDate?: string | null;
  endDate?: string | null;
}

export function useAuditLog(params: AuditLogParams = {}) {
  return useQuery({
    queryKey: auditLogKeys.list(params),
    queryFn: async (): Promise<AuditLogListResponse> => {
      const url = new URLSearchParams();
      if (params.limit) url.set("limit", String(params.limit));
      if (params.cursor) url.set("cursor", params.cursor);
      if (params.entityType) url.set("entityType", params.entityType);
      if (params.tableName) url.set("tableName", params.tableName);
      if (params.entityName) url.set("entityName", params.entityName);
      if (params.changeType) url.set("changeType", params.changeType);
      if (params.adminId) url.set("adminId", params.adminId);
      if (params.startDate) url.set("startDate", params.startDate);
      if (params.endDate) url.set("endDate", params.endDate);
      const res = await fetch(`/api/audit-log?${url}`);
      if (!res.ok) throw new Error("Failed to fetch audit log");
      return res.json();
    },
  });
}
